import { connectHits } from "instantsearch.js/es/connectors/index.js";

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Show total results
export const chamfrResultsHeader = connectHits(
  (renderOptions, isFirstRender) => {
    const { widgetParams, hits = [], results, isSearchStalled } = renderOptions;
    const container = widgetParams.container;

	const hitsPerPage = renderOptions.results?.hitsPerPage || 30;

    // Explicitly extract nbHits from the correct part of the response
    const nbHits = renderOptions.results?.nbHits || 0;

    // Use hits.length as a fallback if nbHits is 0
    const totalHits = nbHits > 0 ? nbHits : hits.length;

	if (isSearchStalled || !results) {
		container.innerHTML = "<h2>Loading...</h2>";
		return;
	}

    if (totalHits === 0) {
      const isProductsTab = !!container?.closest?.(".chamfr-search-tab-products");
      const tabRoot = isProductsTab ? container.closest(".chamfr-search-tab-products") : null;
      const hasCharliUi = !!tabRoot?.querySelector?.("#chamfr-assistant, #chamfr-assistant-cta");

      if (isProductsTab && hasCharliUi) {
        container.innerHTML = "";
        return;
      }

      container.innerHTML = `<h2>No results found</h2>`;
      return;
    }

    // Calculate dynamic range
    const start =
      totalHits > 0 ? results.page * hitsPerPage + 1 : 0;
    const end = Math.min(totalHits, start + hits.length - 1);

    const scopeLabel =
      typeof widgetParams.scopeLabel === "function"
        ? widgetParams.scopeLabel()
        : widgetParams.scopeLabel;
    const scopeSuffix = scopeLabel ? ` &middot; ${escapeHtml(scopeLabel)}` : "";

    // Update header with results range
    container.innerHTML = `<h2>${start}-${end} of ${totalHits} <span>Results${scopeSuffix}</span></h2>`;
  }
);
